import React from 'react'
import styled from 'styled-components'

interface FloatingButtonProps {
  isVisible: boolean
  children: React.ReactNode
}

const FloatingButton: React.FC<FloatingButtonProps> = ({
  isVisible,
  children,
}) => {
  return <ScrollButton $visible={isVisible}>{children}</ScrollButton>
}

export default FloatingButton

const ScrollButton = styled.div<{ $visible: boolean }>`
  will-change: transform;

  position: fixed;
  z-index: 10;
  right: 0;
  bottom: 30px;
  left: 0;

  display: ${(props) => (props.$visible ? 'flex' : 'none')};

  padding: 0 20px;

  transition: opacity 0.3s;
`
